export enum SupportTicketPriority {
  Urgent = "URGENT",
}
